import {
  Box,
  Button,
  Img,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { v4 } from 'uuid';
import newsImage from '../../../assets/boyImage.jpg';

const SingleNewsCard = ({ content, image, title }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box
        onClick={onOpen}
        shadow='md'
        // borderRadius='5px'
        // overflow={'hidden'}
        // w='90%'
        // pos='relative'
        className='news-card-container'
      >
        <Img
          objectFit='cover'
          src={image[0] || newsImage}
          w='100%'
          h='120px'
          alt='guy'
        />
        <Box className='post_card_text_container'>
          <Text fontWeight={600} className='text'>
            # {title}
          </Text>
          <Text fontWeight={500} className='text'>
            {content}
          </Text>
        </Box>
      </Box>

      <Modal
        size='xs'
        motionPreset='slideInBottom'
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign='center'>{title}</ModalHeader>

          <ModalBody>
            <Stack py='2' spacing='5'>
              {image.map((i) => (
                <Img
                  key={v4()}
                  src={i}
                  h='180px'
                  objectFit='cover'
                  alt={title}
                />
              ))}

              <Text>{content}</Text>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Button size='sm' variant='outline' onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SingleNewsCard;
